import React from 'react';
import {
  Box,
  HeadingText,
  GDSStyleObject,
  Card,
  TextAction,
} from '@leagueplatform/genesis-core';
import { useNavigateLegacy as useNavigate } from '@leagueplatform/routing';

export const PageHeader = ({
  showBackButton = true,
}: {
  showBackButton?: boolean;
}) => {
  const navigate = useNavigate();
  return (
    <Card.Flat
      css={
        {
          backgroundColor: '#EAF5FD',
        } as GDSStyleObject
      }
    >
      <Card.Section
        css={
          {
            boxSizing: 'border-box',
            margin: '0px auto',
            width: '100%',
            maxWidth: '1132px',
          } as GDSStyleObject
        }
      >
        <Box>
          {showBackButton && (
            <TextAction
              onClick={() => navigate(-1)}
              as="button"
              icon="interfaceChevronLeft"
              css={{
                color: '$onSurfaceIconPrimary',
                marginBottom: '$half',
                position: 'relative',
                top: '34px',
              }}
            >
              {/* eslint-disable-next-line react/jsx-curly-brace-presence */}
              {''}
            </TextAction>
          )}
          <Box
            css={{
              display: 'inline-flex',
              height: '110px',
            }}
          >
            <HeadingText
              level="1"
              size={{ '@initial': 'xxl', '@mobile': 'xl' }}
              css={{
                position: 'relative',
                top: '32px',
              }}
            >
              Account Management
            </HeadingText>
          </Box>
        </Box>
      </Card.Section>
    </Card.Flat>
  );
};
